import { SliderPaginationElement } from './slider-pagination';

customElements.define(
  'eo-slider-pagination',
  // @ts-ignore
  SliderPaginationElement
);
